import { gElementStore } from "../stores";

export const useGElementStore = () => gElementStore;
